import React from "react";

export const SkeletonCard = ({ className = "" }) => (
  <div className={`card-celestial rounded-2xl p-5 space-y-3 ${className}`}>
    <div className="h-3 w-20 rounded bg-surface/60 animate-pulse" />
    <div className="h-7 w-16 rounded bg-surface/60 animate-pulse" />
    <div className="h-2.5 w-28 rounded bg-surface/60 animate-pulse" />
  </div>
);

export const SkeletonRow = () => (
  <div className="p-4 flex items-center justify-between gap-4">
    <div className="space-y-2 flex-1">
      <div className="h-3 w-1/3 rounded bg-surface/60 animate-pulse" />
      <div className="h-2.5 w-1/2 rounded bg-surface/40 animate-pulse" />
    </div>
    <div className="h-6 w-16 rounded-full bg-surface/60 animate-pulse shrink-0" />
  </div>
);

export const SkeletonTable = ({ rows = 5 }) => (
  <div className="card-celestial rounded-2xl divide-y divide-celestial-border/10">
    {Array.from({ length: rows }).map((_, i) => (
      <SkeletonRow key={i} />
    ))}
  </div>
);
